import React from "react";
import "./Home.css";
import { Card, ButtonIcon } from "../../components";
import Purchase from "../Purchase/Purchase";
import Data from "../Data/Data";
import Generate from "../Generate/Generate";
import RecentOrders from "../RecentOrders/RecentOrders";
import Fab from "@material-ui/core/Fab";
import ColorPicker from "../../layout/ColorPicker";
import EditIcon from "@material-ui/icons/Edit";
import { useTheme } from "../../contexts/ThemeContext";

export default function Home() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { setEditClicked } = useTheme();

  const handleClick = (event) => {
    setEditClicked(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="home">
      <div className="w__60">
        <Generate />
        <Card>
          <RecentOrders />
        </Card>

        <Card>
          <h1>Support</h1>
          <p className="support__para">
            If you have any questions, feel free to join our Discord and make a
            ticket. You can also find us on Twitter
          </p>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <ButtonIcon title="Discord" icon="discord" />
            <div style={{ marginRight: 7 }} />
            <ButtonIcon title="Twitter" icon="twitter" />
          </div>
        </Card>
      </div>

      <div className="w__40">
        <Card>
          <Data />
        </Card>
        {/* Purchasing proxies */}
        <Card>
          <Purchase />
          {/* {currentBuyingPrice} */}
        </Card>
      </div>
      <Fab
        color="secondary"
        aria-label="edit"
        onClick={handleClick}
        style={{ position: "absolute", left: "95%", top: "0%" }}
      >
        <EditIcon />
      </Fab>
      <ColorPicker handleClose={handleClose} open={open} anchorEl={anchorEl} />
    </div>
  );
}
